var React = require('react');

function IconHeartOutlinedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"1.4","d":"M4.208.7a3.49 3.49 0 0 1 2.48 1.03L8 3.049l1.313-1.317A3.49 3.49 0 0 1 11.793.7 3.52 3.52 0 0 1 15.3 4.223a3.52 3.52 0 0 1-1.03 2.491l-.816.82-5.24 5.26-5.67-5.26-.817-.82A3.519 3.519 0 0 1 .7 4.223 3.519 3.519 0 0 1 4.208.7z","fill":"none"}));
}

IconHeartOutlinedInline.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = IconHeartOutlinedInline;

IconHeartOutlinedInline.default = IconHeartOutlinedInline;
